import React, { Component } from 'react'
import T from 'i18n-react'
import { Flex } from 'reflexbox'
import {
  Dropdown,
  IconButton,
} from 'react-toolbox'
import CSSModules from 'react-css-modules'

import {
  FILTER_ALL,
  FILTER_RISK,
  FILTER_MODIFIED,
} from './constants'

import styles from './styles.scss'

class FilterDropdown extends Component {
  constructor(props) {
    super(props)

    this.state = {
      filter: 'all',
    }

    const getLabel = (key) => T.translate(`project.spec.filter.${key}`)

    this.filter = [
      { value: FILTER_ALL, icon: 'description', label: getLabel(FILTER_ALL)},
      { value: FILTER_RISK, icon: 'warning', label: getLabel(FILTER_RISK)},
      { value: FILTER_MODIFIED, icon: 'edit', label: getLabel(FILTER_MODIFIED)},
    ]
  }


  handleFilterChange = (value) => {
    this.setState({filter: value})
    this.props.onSelectFilter(value)
  }

  customItem(item) {
    const itemWrapperStyle = {
      alignItems: 'center'
    }

    return(
      <Flex style={itemWrapperStyle}>
        <IconButton icon={item.icon} />
        <span>{item.label}</span>
      </Flex>
    )
  }

  render() {
    return(
      <Dropdown
        source={this.filter}
        onChange={this.handleFilterChange}
        label='Select Filter'
        template={this.customItem}
        value={this.props.curFilter}
        theme={styles}
      />
    )
  }
}

export default CSSModules(FilterDropdown, styles)
